import Player from 'react-lottie-player';
import animationData from '../Dot/Animation.json';
import styles from "./Dot.module.css";

const Dot = () => {
    return (
        <div className={styles.dotContainer}>
            {/* Tamanho controlado por .player no CSS, seguindo o padrão do sistema:
                800px no desktop, 600/400/300 nos breakpoints 900/700/500px */}
            <div className={styles.player}>
                <Player
                    loop
                    animationData={animationData}
                    play
                    style={{ width: '100%', height: '100%', margin: 0, padding: 0 }}
                />
            </div>
        </div>
    );
};

export default Dot;
